export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
